<div class="modal-card card" ngbAutoFocus>
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h3 class="card-header-title" *ngIf="step === 1 || step === 5">{{ 'SELECT_SEATS_MODAL.SELECT_SEATS_TITLE' | translate }}</h3>
        <h3 class="card-header-title" *ngIf="step === 2">{{ 'SELECT_SEATS_MODAL.CONFIRM_SELECTED_TITLE' | translate }}</h3>
        <h3 class="card-header-title" *ngIf="step === 3 || step === 4">{{ 'SELECT_SEATS_MODAL.ADD_SEATS_TITLE' | translate }}</h3>
      </div>
      <div class="col-auto">
        <i
          data-dismiss="modal"
          (click)="emitDismiss.emit(true)"
          class="material-icons float-right ml-3 close-icon"
        >close</i>
      </div>
    </div>
  </div>
  <div class="card-body modal-card-body-height" #cardBodyContainer>
    <ng-container *ngIf="step === 1">
      <div class="loader-wrapper" *ngIf="seatMapService.showSeatAvailabilityLoader">
        <app-loader></app-loader>
      </div>

      <div *ngIf="responseWarnings.length" class="row">
        <div class="col alert-warning m-3 p-3 rounded">
          <ul>
            <li *ngFor="let item of responseWarnings">{{item}}</li>
          </ul>
        </div>
      </div>

      <div *ngIf="!seatMapService.showSeatAvailabilityLoader">
        <error-alert-block
          [error]="seatMapService.seatAvailabilityError"
        ></error-alert-block>
      </div>

      <ng-container *ngIf="(seatMapService.seats | pairsImpure).length > 0">
        <app-seat-map
          [seats]="order?.seats"
          [segments]="segments"
          [passengers]="order?.passengers | excludePassengersPipe | sortPassengers"
          [seatAvailability]="seatAvailability"
          (seatSelect)="onSeatSelect($event)">
        </app-seat-map>
      </ng-container>

    </ng-container>

    <ng-container *ngIf="step === 2 && (selectedSeatsCopy | pairsImpure).length">
      <error-alert-block
        [error]="orderChangeSeatError"
      ></error-alert-block>
      <div class="table-responsive">
        <table class="table table-default mb-0">
          <thead>
          <tr>
            <th>{{ 'SELECT_SEATS_MODAL.CONFIRM_TABLE.PASSENGER' | translate }}</th>
            <th>{{ 'SELECT_SEATS_MODAL.CONFIRM_TABLE.FLIGHT_SEGMENT' | translate }}</th>
            <th>{{ 'SELECT_SEATS_MODAL.CONFIRM_TABLE.SEAT' | translate }}</th>
            <th>{{ 'SELECT_SEATS_MODAL.CONFIRM_TABLE.PRICE' | translate }}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let obj of (selectedSeatsCopy | pairsImpure)">
            <ng-container *ngIf="obj[1] | isInstanceOfObject">
              <tr *ngFor="let seatObj of (obj[1] | pairsImpure)">
                <td>{{order.passengers | getPassengerNameByRefPipe:seatObj[1]}}</td>
                <td class="whitespace-pre-line">{{order.flights | getSegmentRouteByIDPipe:obj[0]}}</td>
                <td>
                  {{seatObj[0]}}
                </td>
                <td>
                  {{seatMapService.originalSeatList | getSeatInfo: obj[0] : seatObj[0] : seatObj[1]}}
                </td>
              </tr>
            </ng-container>
          </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 3">
      <div class="payment-form-wp">
        <app-payment-form
          [validateTriggered]="validateTriggered"
          [paymentWarnings]="orderChangeSeatWarnings"
          [paymentError]="orderChangeSeatError"
          [allowedPaymentMethods]="order.allowedPaymentMethods"
          [cardSurchargesMap]="order.cardSurchargesMap"
          [totalPrice]='seatsTotalPrice'
          [logs]="order.logs"
          [owner]="order.bookingReference?.airlineID">
        </app-payment-form>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 4">
      <app-payment-info
        [order]="order"
        [type]="'pay_ancillaries_on_orderchange'"
        [shouldProcessSelectedSeats]="true"
        [paymentError]="orderChangeSeatError"
        (emitPaymentInfoError)="isPaymentInfoError = $event"
        (emitStepBack)="onStepBack()"
        (emitUpdatedOfferID)="onUpdatedOfferID($event)">
      </app-payment-info>
    </ng-container>

    <ng-container *ngIf="step === 5">
      <div class="mb-3" *ngIf="orderChangeSeatWarnings.length">
        <app-show-warnings [warnings]="orderChangeSeatWarnings"></app-show-warnings>
      </div>
      <div class="alert alert-success mb-0">
        {{ 'SELECT_SEATS_MODAL.SELECTED_SEATS_ORDERED' | translate }}
      </div>
    </ng-container>
  </div>

  <div class="card-footer text-right">
    <ng-container *ngIf="step === 1">
      <div class="select-seats-first-step-footer-wp">
        <div class="text-warn" *ngIf="(seatMapService.seats | pairsImpure).length"
             [ngClass]="{'text-red': hasNotFullSeatsForSegment }">
          {{ 'SELECT_SEATS_MODAL.SELECT_SEAT_WARNING' | translate }}
        </div>
        <div class="button-wp">
          <button
            type="button"
            class="btn btn-secondary mr-3"
            (click)="emitDismiss.emit(true);">
            {{ 'BUTTONS.CANCEL' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="!(!hasNotFullSeatsForSegment && hasFullSeatsForSegment)"
            (click)="showSelectedServices()">
            {{ 'BUTTONS.NEXT' | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 2">
      <div class="btn mr-3" *ngIf="paymentLoader">
        <app-loader></app-loader>
      </div>
      <button
        type="button"
        class="btn btn-secondary mr-3"
        [disabled]="paymentLoader"
        (click)="setStep(1);">
        {{ 'BUTTONS.BACK' | translate }}
      </button>
      <app-popover-wrapper
        popoverContent="Airline does not allow booking on hold."
        [disablePopover]="order.status === ORDER_STATUS.PENDING ||
                          order.status === ORDER_STATUS.TICKETED && order.allowedRequests?.ticketed?.AncillariesOnHold"
        [additionalClasses]="order.status !== ORDER_STATUS.PENDING ? 'd-inline-block mr-3' : 'd-inline-block'"
      >
        <button
          type="button"
          class="btn btn-tonal-primary"
          [disabled]="(order.status === ORDER_STATUS.TICKETED && !order.allowedRequests?.ticketed?.AncillariesOnHold) || paymentLoader"
          (click)="requestSeats(true)">
          {{ 'BUTTONS.BOOK_ON_HOLD' | translate }}
        </button>
      </app-popover-wrapper>
      <app-popover-wrapper
        *ngIf="order.status !== ORDER_STATUS.PENDING"
        popoverContent="Your User Role does not have the permission to proceed with this action."
        [disablePopover]="ls.role !== ROLES.BOOKER"
        additionalClasses="d-inline-block"
      >
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="ls.role === ROLES.BOOKER"
          (click)="setStep(3)"
        >
          {{ 'BUTTONS.BOOK_AND_PAY' | translate }}
        </button>
      </app-popover-wrapper>
    </ng-container>

    <ng-container *ngIf="step === 3">
      <div class="btn mr-3" *ngIf="paymentLoader">
        <app-loader></app-loader>
      </div>
      <button
        type="button"
        class="btn btn-secondary mr-3"
        [disabled]="paymentLoader"
        (click)="setStep(2)">
        {{ 'BUTTONS.BACK' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="paymentLoader"
        (click)="proceedStep3()">
        {{ 'BUTTONS.PROCEED' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="step === 4">
      <div class="btn mr-3" *ngIf="paymentLoader">
        <app-loader></app-loader>
      </div>
      <button
        type="button"
        class="btn btn-secondary mr-3"
        [disabled]="paymentLoader"
        (click)="setStep(3)">
        {{ 'BUTTONS.BACK' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="isPaymentInfoError || paymentLoader || paymentService.isNonePaymentMethod"
        (click)="requestSeats()">
        {{ 'BUTTONS.PROCEED' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="step === 5">
      <button
        type="button"
        class="btn btn-primary mr-3"
        (click)="emitDismiss.emit(true);">
        {{ 'BUTTONS.OK' | translate }}
      </button>
    </ng-container>
  </div>
</div>
